var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_vm._t("header-before"),_c('div',{staticClass:"header__logo"},[_c('router-link',{attrs:{"to":{ name: 'Login' }}},[_c('img',{attrs:{"src":require('@/assets/svg/brand-logo.svg'),"alt":"Brand logo"}})])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }